















import commons from "@/common/store/modules/commons";
import { Prop, Vue, Component } from "vue-property-decorator";
import { mapState } from "vuex";

@Component({
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  }
})
export default class ButtonMore extends Vue {
  @Prop({ type: String, default: "button" }) tag!: string;
  @Prop({ type: [String, Boolean], default: false }) href!: string | boolean;

  clickMoreButton() {
    this.$emit("click-more-button");
  }
}
